export default __webpack_public_path__ + "static/n-ost-73ba54f639ad740364c37ba053601f56.png";